import React from 'react';
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Box,
  Paper,
  Avatar,
  Divider,
  Chip,
} from '@mui/material';
import { AccountCircle, CalendarToday, LocationOn } from '@mui/icons-material';
import { formatDate } from '../../../../utilities/formatter';

const OfficerCard = ({ officer, type }) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <Avatar
          sx={{
            width: 56,
            height: 56,
            mr: 2,
            bgcolor: type === 'director' ? 'primary.light' : 'secondary.light',
          }}
        >
          <AccountCircle sx={{ fontSize: 32 }} />
        </Avatar>
        <Box sx={{ flexGrow: 1 }}>
          <Typography fontWeight="bold">{officer.name}</Typography>
          <Typography variant="body2" color="text.secondary">
            {type === 'director' ? 'Director' : 'Secretary'} •{' '}
            {officer.nationality}
          </Typography>

          <Divider sx={{ my: 1 }} />

          <Grid container spacing={1}>
            {officer.dateOfBirth && (
              <Grid item xs={6}>
                <Typography variant="body2">
                  <CalendarToday
                    sx={{
                      verticalAlign: 'middle',
                      fontSize: 16,
                      mr: 0.5,
                    }}
                  />
                  {formatDate(officer.dateOfBirth)}
                </Typography>
              </Grid>
            )}
            <Grid item xs={officer.dateOfBirth ? 6 : 12}>
              <Typography variant="body2">
                <CalendarToday
                  sx={{
                    verticalAlign: 'middle',
                    fontSize: 16,
                    mr: 0.5,
                  }}
                />
                Appointed: {formatDate(officer.appointedOn)}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2">
                <LocationOn
                  sx={{
                    verticalAlign: 'middle',
                    fontSize: 16,
                    mr: 0.5,
                  }}
                />
                {officer.serviceAddress.street}, {officer.serviceAddress.city},{' '}
                {officer.serviceAddress.postalCode}
              </Typography>
            </Grid>
            {officer.occupation && (
              <Grid item xs={12}>
                <Typography variant="body2">
                  Occupation: {officer.occupation}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>
    </Paper>
  );
};

const OfficersTab = ({ company }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        Company Officers
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
                Directors
                <Chip
                  label={company?.Officers?.directors?.length || 0}
                  size="small"
                  sx={{ ml: 1 }}
                />
              </Typography>

              {company?.Officers?.directors?.map((director, i) => (
                <OfficerCard key={i} officer={director} type="director" />
              ))}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
                Secretaries
                <Chip
                  label={company?.Officers?.secretaries?.length || 0}
                  size="small"
                  sx={{ ml: 1 }}
                />
              </Typography>

              {company?.Officers?.secretaries?.length > 0 ? (
                company?.Officers.secretaries.map((secretary, i) => (
                  <OfficerCard key={i} officer={secretary} type="secretary" />
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No secretaries appointed
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OfficersTab;
